import ClientNavbar from "../components/ClientNavbar";
import Footer from "../components/Footer";
import "../styles/legal.css";

function Terms() {
  return (
    <>
      <ClientNavbar />

      <main className="legal-page">
        <h1>Terms & Conditions</h1>

        <p>
          By using CompExams, you agree to these Terms & Conditions.
          Please read them carefully before using the website.
        </p>

        <h2>Use of the Website</h2>
        <p>
          CompExams provides examination papers and related
          educational materials for users to access and download.
          You agree to use the website only for lawful purposes.
        </p>

        <h2>Free and Paid Exams</h2>
        <p>
          Some examination materials may be available free of charge,
          while others may require payment before they can be
          downloaded.
        </p>

        <h2>Payments</h2>
        <p>
          Payments for paid examination materials are processed
          through our designated payment provider. You agree to
          provide accurate information when making a payment.
        </p>

        <h2>Downloads and Use of Materials</h2>
        <p>
          Examination materials downloaded from CompExams are
          provided for their intended educational purposes. You are
          responsible for ensuring that your use of downloaded
          materials complies with applicable laws and any applicable
          rights associated with the materials.
        </p>

        <h2>Intellectual Property</h2>
        <p>
          Content made available through CompExams may be protected by
          copyright or other intellectual property rights. You must
          not reproduce, redistribute, sell, or otherwise misuse
          materials unless you have the appropriate permission or
          legal right to do so.
        </p>

        <h2>Website Availability</h2>
        <p>
          We aim to keep CompExams available and functioning properly,
          but we do not guarantee uninterrupted access to the website
          or its services.
        </p>

        <h2>Changes to These Terms</h2>
        <p>
          We may update these Terms & Conditions from time to time.
          Updated terms will be published on this page.
        </p>

        <h2>Contact</h2>
        <p>
          If you have questions about these Terms & Conditions, please
          contact us through the Contact page.
        </p>
      </main>

      <Footer />
    </>
  );
}

export default Terms;
